"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledImageWrapper = exports.StyledImg = exports.StyledFullWidthImgWrapper = exports.StyledImageEditToolbar = void 0;
var styled_components_1 = __importStar(require("styled-components"));
var utilsOolib_1 = require("../../../../utilsOolib");
exports.StyledImageEditToolbar = styled_components_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  position: absolute;\n\n  display: flex;\n  gap: 0.5rem;\n  width: ", ";\n  ", "\n"], ["\n  position: absolute;\n\n  display: flex;\n  gap: 0.5rem;\n  width: ", ";\n  ", "\n"])), function (_a) {
    var underEditImageData = _a.underEditImageData;
    return (!underEditImageData ? "auto" : "100%");
}, function (_a) {
    var containerShape = _a.containerShape, isInPopUp = _a.isInPopUp;
    if (isInPopUp) {
        return (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n            top: 0;\n            right: 0;\n            transform: translateY(-100%);\n        "], ["\n            top: 0;\n            right: 0;\n            transform: translateY(-100%);\n        "])));
    }
    //else it is not in popup
    return containerShape === "circle"
        ? (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n          top: 7%;\n          right: 4%;\n          /* transform: translate(50%, -50%); */\n        "], ["\n          top: 7%;\n          right: 4%;\n          /* transform: translate(50%, -50%); */\n        "]))) : (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n          top: 0;\n            right: 0;\n        "], ["\n          top: 0;\n            right: 0;\n        "])));
});
exports.StyledFullWidthImgWrapper = styled_components_1.default.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  width: 100%;\n  height: 100%;\n  position: relative;\n  \n"], ["\n  width: 100%;\n  height: 100%;\n  position: relative;\n  \n"])));
exports.StyledImg = styled_components_1.default.img(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  /* z-index: -1; */\n  position: absolute;\n  left: 0;\n  top: 0;\n  transform: ", ";\n  margin-left: ", "; //when image is 'contain'ed\n  margin-top: ", "; //when image is 'contain'ed\n  ", "\n"], ["\n  /* z-index: -1; */\n  position: absolute;\n  left: 0;\n  top: 0;\n  transform: ", ";\n  margin-left: ", "; //when image is 'contain'ed\n  margin-top: ", "; //when image is 'contain'ed\n  ", "\n"])), function (_a) {
    var _b = _a.cropX, cropX = _b === void 0 ? 0 : _b, _c = _a.cropY, cropY = _c === void 0 ? 0 : _c;
    return "translate(".concat(cropX, "%,").concat(cropY, "%)");
}, function (_a) {
    var _b = _a.marginLeft, marginLeft = _b === void 0 ? 0 : _b;
    return marginLeft;
}, function (_a) {
    var _b = _a.marginTop, marginTop = _b === void 0 ? 0 : _b;
    return marginTop;
}, function (_a) {
    var fullWidthOrFullHeightImg = _a.fullWidthOrFullHeightImg, imageSpread = _a.imageSpread;
    if (fullWidthOrFullHeightImg === 'fullWidth') {
        return imageSpread === 'cover'
            ? "width: 100%; height: auto;"
            : "\n            height: 100%; \n            width: auto;\n            left: 50%;\n            transform: translateX(-50%);\n          "; //contain
    }
    else if (fullWidthOrFullHeightImg === 'fullHeight') {
        return imageSpread === 'cover'
            ? "height: 100%; width: auto;"
            : "\n            width: 100%; \n            height: auto;\n            top: 50%;\n            transform: translateY(-50%);\n          ";
    }
});
exports.StyledImageWrapper = styled_components_1.default.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  position: relative;\n  height: 100%;\n  border: 2px solid ", ";\n"], ["\n  position: relative;\n  height: 100%;\n  border: 2px solid ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return (0, utilsOolib_1.getPrimaryColor10)(theme === null || theme === void 0 ? void 0 : theme.colors);
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;
